<template>
  <div>
    <OrderDetailTable 
    :planOrderCode="planOrderCode"
     :disabled="disabled" />
  </div>
</template>
<script>
import OrderDetailTable from './components/table'
export default {
  components: { OrderDetailTable },
  props: {
    planOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
}
</script>
